/**
 * Header logo transition on scroll
 * - Swaps large logo to compact logo at 40px scroll
 * - Adds/removes `header-scrolled` class on <body>
 */
export default class HeaderLogoTransition {
    constructor(scrollThresholdPx = 40) {
        this.scrollThresholdPx = scrollThresholdPx;
        this.isScrolled = false;
        this.rafId = null;
        this.onScroll = this.onScroll.bind(this);
        this.update = this.update.bind(this);
        this.init();
    }

    init() {
        // Initial state
        this.isScrolled = window.scrollY >= this.scrollThresholdPx;
        this.requestToggle(this.isScrolled);

        // Listen to scroll
        window.addEventListener('scroll', this.onScroll, { passive: true });
    }

    onScroll() {
        if (this.rafId) return;
        this.rafId = window.requestAnimationFrame(this.update);
    }

    update() {
        this.rafId = null;
        const scrolled = window.scrollY >= this.scrollThresholdPx;
        if (scrolled !== this.isScrolled) {
            this.isScrolled = scrolled;
            this.requestToggle(this.isScrolled);
        }
    }

    requestToggle(nextState) {
        const evt = new CustomEvent('header:request-scroll-toggle', {
            detail: { scrolled: nextState },
            cancelable: true
        });
        const notPrevented = window.dispatchEvent(evt);
        if (notPrevented) {
            const DURATION_MS = 420;
            const logos = document.querySelectorAll('.site-logo');

            // Pre-show incoming image so it participates in sizing immediately
            logos.forEach((logo) => {
                const large = logo.querySelector('.logo-large');
                const compact = logo.querySelector('.logo-compact');
                if (!large || !compact) return;
                if (nextState) {
                    compact.style.display = 'block';
                    large.style.display = 'block';
                } else {
                    large.style.display = 'block';
                    compact.style.display = 'block';
                }
            });

            // Toggle both size (body class) and opacity classes in the same frame
            requestAnimationFrame(() => {
                document.body.classList.toggle('header-scrolled', nextState);
                logos.forEach((logo) => {
                    const large = logo.querySelector('.logo-large');
                    const compact = logo.querySelector('.logo-compact');
                    if (!large || !compact) return;
                    if (nextState) {
                        compact.classList.add('is-visible');
                        large.classList.remove('is-visible');
                    } else {
                        large.classList.add('is-visible');
                        compact.classList.remove('is-visible');
                    }
                });

                // After the fade completes, hide the outgoing layer
                setTimeout(() => {
                    logos.forEach((logo) => {
                        const large = logo.querySelector('.logo-large');
                        const compact = logo.querySelector('.logo-compact');
                        if (!large || !compact) return;
                        if (nextState) {
                            large.style.display = 'none';
                        } else {
                            compact.style.display = 'none';
                        }
                    });
                    window.dispatchEvent(new CustomEvent('header:scrolled-toggle', { detail: { scrolled: nextState } }));
                }, DURATION_MS);
            });
        }
    }
}


